import { createGlobalStyle } from 'styled-components'

export const MainColor = '#FF445C'
export const MainColorText = '#ffffff'

export const GlobalStyle = createGlobalStyle`
  /* Reset CSS */
  *,
  *::before,
  *::after {
    margin: 0;
    padding: 0;
    border: 0;
    font: inherit;
    vertical-align: baseline;
    box-sizing: border-box;
  }

  html {
    font-size: 62.5%;
    width: 100%;
    height: 100%;
  }

  body {
    width: 100%;
    height: 100%;
    min-height: 100vh;
    line-height: 1;
    font-family: 'Spoqa Han Sans Neo', 'Roboto', 'sans-serif';
    overscroll-behavior: none;
  }

  body > #root > div {
    min-height: 100vh;
  }

  /* HTML5 display definitions */
  article, aside, details, figcaption, figure, footer, header, hgroup, menu, nav, section {
    display: block;
  }

  /* Links */
  a {
    color: inherit;
    text-decoration: none;
    outline: none;
  }

  a:hover,
  a:active {
    text-decoration: none;
  }

  /* Typography */
  blockquote, q {
    quotes: none;
  }

  blockquote:before, blockquote:after,
  q:before, q:after {
    content: "";
    content: none;
  }

  /* Tables */
  table {
    border-collapse: collapse;
    border-spacing: 0;
  }

  /* Focus */
  *:focus {
    outline: none;
  }

  /* Scrollbar */
  ::-webkit-scrollbar {
    width: 6px;
    height: 6px;
    background: #001B43;
  }

  ::-webkit-scrollbar-thumb {
    background: #244FA8;
    border-radius: 2px;
  }

  /* Form elements */
  input {
    color: black !important;
  }

  input[type="checkbox"] {
    background: transparent;
  }

  input:-webkit-autofill {
    -webkit-text-fill-color: #99f;
  }

  input:-webkit-autofill:focus {
    -webkit-text-fill-color: #999;
  }

  /* Animations */
  * {
    animation-duration: 0.1s !important;
  }

  @keyframes flashgreen {
    20% {
      background-color: rgba(0, 0, 255, 0.5);
    }
  }

  @keyframes flashred {
    20% {
      background-color: rgba(255, 0, 0, 0.5);
    }
  }

  /* Utility classes */
  .warning {
    color: red;
    font-size: 13px;
    padding: 10px 5px;
  }

  .warn {
    background-color: rgba(255, 0, 0, 0.1);
  }

  .krw {
    text-align: right;
  }

  .krw.plus {
    color: rgb(36, 159, 100);
  }

  .krw.minus {
    color: rgb(239, 69, 74);
  }

  /* Modal styles */
  .modalConfirm {
    font-size: 14px;
  }

  .modalConfirm h1 {
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 10px;
  }

  .confirmationModal {
    animation-duration: 0.1s !important;
  }

  /* AG Grid theme */
  .ag-theme-alpine {
    --ag-material-primary-color: #f00;
    --ag-data-color: #f00;
    --ag-selected-row-background-color: rgb(0, 255, 255, 0.1);
  }

  /* Ant Design table customizations */
  .ant-table-cell {
    padding: 3px 5px !important;
  }

  .child-row .ant-table-cell {
    background-color: #f5f5f5;
    padding: 3px 3px !important;
  }

  .split-row .ant-table-cell {
    border-top: 1px solid #999999;
  }

  .expired-row .ant-table-cell {
    background-color: #f0f0f0;
  }

  .future-row .ant-table-cell {
    background-color: #f0ffff;
  }

  /* Textarea with overflow */
  .ovtextarea textarea {
    max-height: 30px;

    &:focus {
      max-height: 500px;
    }
  }

`
